
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/react-box",
      function () {
        return require("private-next-pages/material-ui/react-box.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/react-box"])
      });
    }
  